// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2d3748',
    },
    background: {
      default: '#eeeeff'
    }
  },

  typography: {
    h1: {
      fontSize: '52px',
    },
    h2: {
      fontSize: '40px',
    },
    h3: {
      fontSize: '32px',
    },
    h4: {
      fontSize: '24px',
    },
    h5: {
      fontSize: '20px',
    },
    h6: {
      fontSize: '16px',
    },
  },

});

theme.components = {
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main,
      },
    },
  }
};

export default theme;
